import { DEFAULT_LOCALE } from 'shared/consts'
import { OFFER_TYPE_SAE } from 'shared/consts/marketplace'
import { isMarketplace } from 'shared/experiments/utils/featureFlags'
import logger from 'shared/services/logger'
import store from 'shared/store'
import { updateNowDataSuccessAction } from 'shared/store/ducks/now/actions'
import { MINIMUM_VALUE_NOT_REACHED } from 'views/consts/notEligibleReasons'
import loadCatalogs from 'views/containers/browser/utils/loadCatalogs'

const containerEl = document.querySelector(
  '[data-clientside-hook="h-nowLabelWithZipInteractionContainer"]'
)
const mount = async container => {
  const {
    publicConfig: { locale = DEFAULT_LOCALE, tenant },
    pageProperties: { product, experiments = [] },
  } = store.getPublicRuntimeConfig()
  const retailPrice = product.prices.find(({ type }) => type === 'retail')
  let price = retailPrice ? retailPrice.amount : 1

  const catalogs = await loadCatalogs(locale)
  const nowLabelWithZipInteractionContainer = await import(
    /* webpackChunkName: "NowLabelWithZipInteractionContainerWithRender", webpackPrefetch: true */
    './NowLabelWithZipInteractionContainerWithRender'
  )
  let displayNowWidget = product.nowProductGroup === 'sameday_nextday'

  const data = localStorage.getItem('nowData')
  const nowDataState = data ? JSON.parse(data) : null

  let validatedBestOffer = product.bestOffer

  // Fallback, not getting bestOffer from PimCache reliably
  if (!validatedBestOffer) {
    validatedBestOffer =
      product.offers?.find(offer => offer.offerFlags?.includes('bestPrice')) ||
      undefined
  }

  const isMarketplaceSwitch = isMarketplace(experiments, tenant)
  if (displayNowWidget && isMarketplaceSwitch) {
    displayNowWidget = validatedBestOffer?.offerType === OFFER_TYPE_SAE
  }

  let productNowEligible = false

  try {
    if (nowDataState?.zipCode) {
      productNowEligible =
        nowDataState.nowEligible ||
        nowDataState.notEligibleReason === MINIMUM_VALUE_NOT_REACHED

      store.dispatch(
        updateNowDataSuccessAction({
          ...nowDataState,
          refreshNowData: true,
        })
      )
    }
  } catch (error) {
    logger.error(error)
  }

  nowLabelWithZipInteractionContainer.default({
    container,
    catalogs,
    upid: product.upid,
    price,
    displayNowWidget,
    productNowEligible,
  })
}

export default () => {
  if (containerEl) {
    mount(containerEl)
  }
}
